/**
 * Account domain constants — ported 1:1 from
 * `_legacy/components/Accounts/constants.js`.
 *
 * The legacy file also exported `ACCOUNT_TABS` and `ACCOUNT_COLUMNS`
 * (list-page column schema). Tabs don't carry over — the v3 Account
 * Edit page uses a section-rail instead of tabs — and the list
 * columns stay in the legacy AccountsList page for now, so they
 * aren't re-exported here.
 */

export const ACCOUNT_TYPES = {
  STANDARD: 'standard',
  DISTRIBUTION_SPONSOR: 'distributionSponsor',
};

export const STATES = [
  { label: 'Alabama', value: 'AL' },
  { label: 'Alaska', value: 'AK' },
  { label: 'Arizona', value: 'AZ' },
  { label: 'Arkansas', value: 'AR' },
  { label: 'California', value: 'CA' },
  { label: 'Colorado', value: 'CO' },
  { label: 'Connecticut', value: 'CT' },
  { label: 'Delaware', value: 'DE' },
  { label: 'Florida', value: 'FL' },
  { label: 'Georgia', value: 'GA' },
  { label: 'Hawaii', value: 'HI' },
  { label: 'Idaho', value: 'ID' },
  { label: 'Illinois', value: 'IL' },
  { label: 'Indiana', value: 'IN' },
  { label: 'Iowa', value: 'IA' },
  { label: 'Kansas', value: 'KS' },
  { label: 'Kentucky', value: 'KY' },
  { label: 'Louisiana', value: 'LA' },
  { label: 'Maine', value: 'ME' },
  { label: 'Maryland', value: 'MD' },
  { label: 'Massachusetts', value: 'MA' },
  { label: 'Michigan', value: 'MI' },
  { label: 'Minnesota', value: 'MN' },
  { label: 'Mississippi', value: 'MS' },
  { label: 'Missouri', value: 'MO' },
  { label: 'Montana', value: 'MT' },
  { label: 'Nebraska', value: 'NE' },
  { label: 'Nevada', value: 'NV' },
  { label: 'New Hampshire', value: 'NH' },
  { label: 'New Jersey', value: 'NJ' },
  { label: 'New Mexico', value: 'NM' },
  { label: 'New York', value: 'NY' },
  { label: 'North Carolina', value: 'NC' },
  { label: 'North Dakota', value: 'ND' },
  { label: 'Ohio', value: 'OH' },
  { label: 'Oklahoma', value: 'OK' },
  { label: 'Oregon', value: 'OR' },
  { label: 'Pennsylvania', value: 'PA' },
  { label: 'Rhode Island', value: 'RI' },
  { label: 'South Carolina', value: 'SC' },
  { label: 'South Dakota', value: 'SD' },
  { label: 'Tennessee', value: 'TN' },
  { label: 'Texas', value: 'TX' },
  { label: 'Utah', value: 'UT' },
  { label: 'Vermont', value: 'VT' },
  { label: 'Virginia', value: 'VA' },
  { label: 'Washington', value: 'WA' },
  { label: 'West Virginia', value: 'WV' },
  { label: 'Wisconsin', value: 'WI' },
  { label: 'Wyoming', value: 'WY' },
  { label: 'District of Columbia', value: 'DC' },
];

export const CLAIM_REPORT_TYPE_VALUES = {
  WITHOUT_FINANCIAL: 'templateA',
  WITH_FINANCIAL: 'templateB',
};

/**
 * i18n-aware factory — `forms` is expected to be
 * `useSelector(s => s.i18n?.en?.forms)`. Kept as a factory (same as
 * legacy) so consumers thread localisation through without adding a
 * redux subscription here.
 */
export const getClaimReportTypes = (forms = {}) => [
  { label: forms.claimReportWithoutFinancial, value: CLAIM_REPORT_TYPE_VALUES.WITHOUT_FINANCIAL },
  { label: forms.claimReportWithFinancial, value: CLAIM_REPORT_TYPE_VALUES.WITH_FINANCIAL },
];
